import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "#00B388",
      strokeWidth: 1.5,
      d: "M.75 8A7.25 7.25 0 0 1 8 .75h16A7.25 7.25 0 0 1 31.25 8v16A7.25 7.25 0 0 1 24 31.25H8A7.25 7.25 0 0 1 .75 24z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00B388",
      fillRule: "evenodd",
      d: "M11.36 10.653a.5.5 0 0 0-.378-.152.5.5 0 0 0-.33.152.5.5 0 0 0-.151.329.5.5 0 0 0 .152.378l4.646 4.646-4.646 4.647a.5.5 0 0 0-.152.378c.008.129.068.245.152.329s.2.144.329.151a.5.5 0 0 0 .378-.151l4.646-4.647 4.647 4.647c.11.11.244.16.378.151a.5.5 0 0 0 .329-.151.5.5 0 0 0 .151-.33.5.5 0 0 0-.151-.378l-4.647-4.646 4.647-4.646a.5.5 0 0 0 .151-.378.5.5 0 0 0-.151-.33.5.5 0 0 0-.33-.151.5.5 0 0 0-.378.152l-4.646 4.646z",
      clipRule: "evenodd"
    }
  )
);
var SvgCloseOutline = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CloseOutline_default = SvgCloseOutline;

export { CloseOutline_default as default };
